import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { DeleteButton, EditLink } from "../_components/AdminRowActions";

const GarageItem = ({
  garage: { _id, name, prefecture, lon, lat, isActive, defaultGarage, availableVehicleTypes },
  removeGarage,
  count,
}) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{name}</td>
    <td className={cellClass}>
      <div className="tw:flex tw:flex-col tw:gap-1">
        {(prefecture || []).map((l) => (
          <span key={l.value} className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none">
            {l.value}
          </span>
        ))}
      </div>
    </td>
    <td className={`${cellClass} tw:whitespace-nowrap`}>{`${lat}, ${lon}`}</td>
    <td className={cellClass}>
      <div className="tw:flex tw:flex-col tw:gap-1">
        {(availableVehicleTypes || []).filter(Boolean).map((v) => (
          <span key={v._id} className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none">
            {v.typename}
          </span>
        ))}
      </div>
    </td>
    <td className={cellClass}>
      <AdminBadge tone={isActive ? "success" : "neutral"}>{isActive ? "Active" : "Inactive"}</AdminBadge>
    </td>
    <td className={cellClass}>{defaultGarage ? <AdminBadge tone="info">Default</AdminBadge> : "-"}</td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <EditLink to={`/admin/garagelist/edit/${_id}`} label="Edit garage" />
        <DeleteButton
          label="Delete garage"
          onClick={() => removeGarage(_id)}
        />
      </AdminRowActions>
    </td>
  </tr>
);

export default GarageItem;
